import React, { Component } from 'react'
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import history from '../../routes/history'
import * as actionCreator from '../../redux/actions/data-action';
import { TaskSegment, getTaskTypeIdById } from '../../redux/actions/data-action';
import { Box } from '../../third-party-components/material-ui';
import NextButton from './../../assets/images/next@2x.png';

import { AssessmentContainer, AssessmentBody,
            AssessmentContent, AssessmentNavigationPrevious, AssessmentNavigationNext, AssessmentFooter,
            AssessmentContentHeader, AssessmentContentSection, AssessmentContentAction, AssessmentContentActionButton
} from './common';

const toPrevious = "/Demographic/Rater";

class AssessmentInstructionSpanishParent extends Component {
  componentDidMount()
  {
    window.history.pushState(null, null, history.location.href);
      window.onpopstate = function(event) {
          history.go(1);
      };
  }

    getFirstTaskTypeLink() {
        const { taskTypes } = this.props;
        const taskType = getTaskTypeIdById(taskTypes[0].id);

        var hasPractice = taskTypes[0].practice.length > 0

        return hasPractice ? `/Assessment/Tasks/${taskType.type}/${TaskSegment.INSTRUCTION}` : `/Assessment/Tasks/${taskType.type}/${TaskSegment.TASK}/1`;
    }

    handlePrevious() {
        history.push(toPrevious);
    }

    handleNext(nextLink) {
        history.push(nextLink);
    }

    render() {
      const version = parseInt(sessionStorage.getItem('temp-version-id'));

        return (
            <AssessmentContainer>
                <AssessmentContentHeader>Instrucciones</AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent className="assessment-content-introduction">
                        <AssessmentContentSection style={{textAlign: 'left'}}>
                            Nota: mantenga su pantalla maximizada durante la prueba.
                            <br/>
                            <br/>
                            Aquí hay algunas cosas que los padres pueden decir sobre sus hijos(as). Por favor lea cada ítem cuidadosamente y indique cuán cierto o con qué frecuencia le ha sucedido esto a su hijo(a) en el <b>último mes</b>. Piensa si:
                            <br/>
                            <br/>
                            <li>En el último mes, esto <b><i>no fue nada cierto</i></b> para mi hijo(a). <b><i>Nunca o rara vez</i></b> ocurrió.</li>
                            <li>En el último mes, esto fue <b><i>solo un poco cierto</i></b> para mi hijo(a). Ocurrió <b><i>ocasionalmente</i></b>.</li>
                            <li>En el último mes, esto fue <b><i>bastante cierto</i></b> para mi hijo(a). Ocurrió <b><i>a menudo o frecuentemente</i></b>.</li>
                            <li>En el último mes, esto fue <b><i>completamente cierto</i></b> para mi hijo(a). Ocurrió <b><i>muy a menudo o siempre</i></b>.</li>
                            <br/>
                            <br/>
                            Por favor marca solamente una respuesta para cada item. Es importante responder a cada item. Para los itemes que encuentras difícil de contestar, por favor da su mejor suposición.
                            <br/>
                            <br/>
                            <Box>Cuando esté listo, haga clic en el botón {'>'} para avanzar.</Box>
                        </AssessmentContentSection>
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentContentAction>
                        <AssessmentContentActionButton styleType='arrows' onClick={this.handlePrevious}>{'<'}</AssessmentContentActionButton>
                        <AssessmentContentActionButton styleType='arrows' onClick={() => this.handleNext(this.getFirstTaskTypeLink())}>{'>'}</AssessmentContentActionButton>
                    </AssessmentContentAction>
                <AssessmentFooter includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

const mapStateToProps = (state, ownState) => (
    
    {
    taskTypes : state.data.tasks
})

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentInstructionSpanishParent));